import React, { forwardRef } from 'react';
import cn from 'classnames';

export enum StackDirection {
  LeftToRight,
  RightToLeft,
  TopDown,
  BottomUp,
}

interface StackProps {
  direction?: StackDirection;
  className?: string;
  children: React.ReactNode;
  onClick?: React.MouseEventHandler;
}

const getDirectionalClass = (direction: StackDirection) => {
  switch (direction) {
    case StackDirection.LeftToRight:
      return 'across';
    case StackDirection.RightToLeft:
      return 'reverse';
    case StackDirection.TopDown:
      return 'vertical';
    case StackDirection.BottomUp:
      return 'popup';
  }
};

export const Stack = forwardRef<HTMLDivElement, StackProps>(
  (
    {
      direction = StackDirection.LeftToRight,
      children,
      className,
      onClick,
      ...rest
    },
    ref
  ) => {
    const stackClasses = cn({
      ['stack']: false,
      [getDirectionalClass(direction)]: true,
      ['vertical-stack']: true,
    });
    return (
      <div
        ref={ref}
        className={`${stackClasses} ${className}`}
        onClick={(evt: React.MouseEvent) => {
          onClick && onClick(evt);
        }}
        {...rest}
      >
        {children}
      </div>
    );
  }
);
Stack.displayName = 'Stack';
